module.exports = __webpack_public_path__ + "@/assets/img/visa.7757378e.svg";